import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const FilledLeftIcon: FC<Props> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2856 13.3337C10.0905 13.3337 9.89552 13.259 9.74692 13.1104L5.17557 8.53906C4.87767 8.24119 4.87767 7.75966 5.17557 7.46179L9.74692 2.89042C10.0449 2.59252 10.5263 2.59252 10.8243 2.89042C11.1221 3.18832 11.1221 3.66983 10.8243 3.96773L6.79152 8.00039L10.8243 12.0331C11.1221 12.331 11.1221 12.8125 10.8243 13.1104C10.6757 13.259 10.4807 13.3337 10.2856 13.3337Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default FilledLeftIcon;
